import React, { useState } from 'react';
import { strings } from '@purple-start-registration/common/localization';
import { getPaymentSummary } from '@purple-start-registration/common/registration';

import { EventsForm } from './form';
import { WithLanguage } from '../Language';
import { useForm } from '../../hooks/use-form';
import validations from '../../lib/validations';

const EventsPageComponent = function ({
  config,
  configSection,
  apiBaseUrl,
  language,
}) {
  const [price, setPrice] = useState();
  const [paymentProgress, setPaymentProgress] = useState({
    processing: false,
    error: null,
  });

  const { data, errors, setValues, handleSubmit, handleChange } = useForm({
    initialValues: {
      language,
      configSection,
      acceptTerms: false,
      registerNewsletter: false,
    },
    validations: validations(),
    onValidationFailed: () => {
      setTimeout(function () {
        const section = document.querySelector('.has-error');
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    },
    onSubmit: async () => {
      setPaymentProgress({
        processing: true,
        error: null,
      });

      try {
        const res = await fetch(`${apiBaseUrl}/api/order/checkout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...data,
          }),
        });

        const { status, statusText } = res;
        if (status === 200) {
          const { paymentUrl } = await res.json();
          window.location = paymentUrl;
        } else {
          setPaymentProgress({
            processing: false,
            error: strings.orderError,
          });
        }
      } catch (e) {
        setPaymentProgress({
          processing: false,
          error: strings.orderError,
        });
      }
    },
  });

  /**
   * When the selection changes, we track it and recalculate the price.
   */
  const handleSelectionChange = (selectedEvents) => {
    setValues({
      selection: selectedEvents,
    });

    const updatedPrice = getPaymentSummary(config, { selectedEvents });
    setPrice(updatedPrice);
  };

  if (!config) {
    return <p>Loading...</p>;
  }

  return (
    <form id="events-registration" onSubmit={handleSubmit}>
      <EventsForm
        config={config}
        data={data}
        errors={errors}
        price={price}
        setValues={setValues}
        paymentProgress={paymentProgress}
        handleChange={handleChange}
        handleSelectionChange={handleSelectionChange}
      />
    </form>
  );
};

export const EventsPage = WithLanguage(EventsPageComponent);
